import { render, staticRenderFns } from "./TheWelcomeDialog.vue?vue&type=template&id=3066aaa6"
import script from "./TheWelcomeDialog.vue?vue&type=script&lang=js"
export * from "./TheWelcomeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports